import { Link, useLocation, useNavigate } from "react-router-dom";
import { Search, ShoppingBag } from "lucide-react";
import { useCart } from "../lib/cart";
import { useSearch } from "../lib/search";
import SearchOverlay from "./SearchOverlay";

const links = [
  { label: "SHOP", to: "/shop", testid: "nav-shop-link" },
  { label: "LOOKBOOK", to: "/", hash: "lookbook", testid: "nav-lookbook-link" },
  { label: "MANIFESTO", to: "/", hash: "manifesto", testid: "nav-manifesto-link" },
  { label: "TRACK ORDER", to: "/track", testid: "nav-tracking-link" },
  { label: "ADMIN", to: "/admin", testid: "nav-admin-link" },
];

export default function Nav() {
  const { count, setOpen } = useCart();
  const { openSearch } = useSearch();
  const location = useLocation();
  const navigate = useNavigate();

  const goHash = (e, link) => {
    e.preventDefault();
    if (link.hash && location.pathname !== "/") {
      navigate("/", { state: { scrollTo: link.hash } });
    } else if (link.hash) {
      document.getElementById(link.hash)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(link.to);
    }
  };

  return (
    <>
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#060709]/85 border-b border-white/10">
      <div className="flex items-center justify-between px-5 md:px-10 h-14 md:h-16">
        <Link to="/" data-testid="brand-logo-link" className="font-display text-xl tracking-tight">
          <span className="font-extrabold">RVIOR</span>
          <span className="text-volt align-super text-[10px] font-mono ml-0.5">®</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.to}
              data-testid={l.testid}
              onClick={(e) => goHash(e, l)}
              className="font-mono text-[11px] tracking-[0.22em] text-dim hover:text-acid transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button
            data-testid="nav-search-trigger"
            onClick={() => openSearch()}
            aria-label="Search products"
            className="flex items-center justify-center border border-white/15 text-dim hover:border-acid hover:text-acid transition-colors duration-300 px-3 py-2"
          >
            <Search size={14} />
          </button>
          <button
            data-testid="nav-cart-trigger"
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 font-mono text-[11px] tracking-[0.22em] border border-white/15 px-4 py-2 hover:border-acid hover:text-acid transition-colors duration-300"
          >
            <ShoppingBag size={14} />
            <span className="hidden sm:inline">CART</span>
            <span data-testid="cart-count-badge" className="text-volt">{String(count).padStart(2, "0")}</span>
          </button>
        </div>
      </div>
      <nav className="md:hidden flex items-center gap-5 overflow-x-auto px-5 pb-2.5 -mt-1">
        {links.map((l) => (
          <a
            key={l.label}
            href={l.to}
            data-testid={l.testid}
            onClick={(e) => goHash(e, l)}
            className="font-mono text-[10px] tracking-[0.2em] text-dim hover:text-acid transition-colors whitespace-nowrap"
          >
            {l.label}
          </a>
        ))}
      </nav>
    </header>
    <SearchOverlay />
    </>
  );
}
